import * as React from 'react';
import styled from 'styled-components';
import SelectableEnrollmentTimelineItem from 'flow-doctor-lib/components/timeline/SelectableEnrollmentTimelineItem';
import { jsx as _jsx } from "react/jsx-runtime";
// Responsible for rendering the "timeline" line between items
const TimelineItemContainer = styled.div.withConfig({
  displayName: "SelectableEnrollmentTimeline__TimelineItemContainer",
  componentId: "sc-1bm3isn-0"
})(({
  theme,
  showLine
}) => `
  margin-bottom: ${theme.space['900']};

  ${showLine && `&::before {
    content: '';
    height: ${theme.space['900']};
    width: ${theme.space['50']};
    background-color: ${theme.color['fill-tertiary-subtle']};
    position: absolute;
    display: block;
    bottom: -${theme.space['900']};
    z-index: 999999;
    left: ${theme.space['800']};
  }`}
`);
const SelectableEnrollmentTimeline = ({
  flowId,
  objectTypeId,
  timelineLogItems,
  onItemSelect
}) => {
  return /*#__PURE__*/_jsx("div", {
    children: timelineLogItems.map((logItem, index) => /*#__PURE__*/_jsx("div", {
      style: {
        position: 'relative'
      },
      children: /*#__PURE__*/_jsx(TimelineItemContainer, {
        showLine: index < timelineLogItems.length - 1,
        children: /*#__PURE__*/_jsx(SelectableEnrollmentTimelineItem, {
          flowId: flowId,
          objectTypeId: objectTypeId,
          logItem: logItem,
          onClick: () => onItemSelect(logItem)
        }, logItem.timestamp)
      })
    }, index))
  });
};
export default SelectableEnrollmentTimeline;